import React from 'react';
import {Select} from 'components/antd';
import useSearchParams from '../../useSearchParams';

const options = [
  {text: 'なし', value: 0},
  {text: 'あり', value: 1},
];

const IsMultipleFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      allowClear
      value={query.isMultiple}
      onChange={(value) => setQuery({page: 1, isMultiple: value})}>
      {options.map((option) => (
        <Select.Option
          value={option.value}
          key={option.text}
          label={option.text}>
          {option.text}
        </Select.Option>
      ))}
    </Select>
  );
};

export default IsMultipleFilter;
